import { history } from '../../store/store';

interface AuthFooterLinkProps {
  text: string;
  linkText: string;
  to: string;
  /** Use an external href instead of history.push */
  external?: boolean;
}

export const AuthFooterLink = ({ text, linkText, to, external }: AuthFooterLinkProps) => {
  const handleClick = () => {
    if (external) {
      window.open(to, '_blank', 'noopener,noreferrer');
    } else {
      history.push(to);
    }
  };

  return (
    <div className="mt-4 text-center text-xs text-greyP2">
      {text}{' '}
      <button type="button" onClick={handleClick} className="text-green01 font-medium hover:underline cursor-pointer">
        {linkText}
      </button>
    </div>
  );
};
